import { render } from "./Tab5.vue?vue&type=template&id=39eb39dc&scoped=true"
import script from "./Tab5.vue?vue&type=script&lang=js"
export * from "./Tab5.vue?vue&type=script&lang=js"

import "./Tab5.vue?vue&type=style&index=0&id=39eb39dc&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39eb39dc"]])

export default __exports__